import { SearchableDropdownOption } from './searchable-dropdown.component';

/** Map an array of objects to searchable dropdown options. */
export function toSearchableOptions<T extends Record<string, unknown>>(
  items: T[] | null | undefined,
  labelKey: keyof T & string,
  valueKey: keyof T & string,
  emptyOption?: { label: string; value: unknown }
): SearchableDropdownOption[] {
  const mapped = (items ?? []).map((item) => ({
    label: String(item[labelKey] ?? ''),
    value: item[valueKey],
  }));
  if (emptyOption) {
    return [{ label: emptyOption.label, value: emptyOption.value }, ...mapped];
  }
  return mapped;
}

/** Map primitive arrays (e.g. string[]) to options. */
export function toSearchableOptionsFromPrimitives(
  items: (string | number)[] | null | undefined
): SearchableDropdownOption[] {
  return (items ?? []).map((item) => ({ label: String(item), value: item }));
}
